module.exports = __webpack_public_path__ + "img/3dloader.466ec83.gif";